// extracted by mini-css-extract-plugin
export default {"QRDiv":"QRPage_QRDiv__Qr+z-"};